import { AgentDealUpdateRequest } from '@repo/database/src/types';

export type CreateAgentDealUpdateRequestDto = Omit<
  AgentDealUpdateRequest,
  | 'id'
  | 'createdAt'
  | 'updatedAt'
  | 'applied'
  | 'currentCycle'
  | 'validFrom'
  | 'createdBy'
  | 'hasPercentageConflict'
  | 'conflictMessage'
> & {
  agentDealId?: string;
};
